// 引入 Vue
// import Vue from 'vue'
import { reportClientError } from '@/utils/clientDiagnostics'

// Facebook Pixel ID
let fb_dynamic_pixelId = ''

function getBrowserWindow() {
  try {
    return typeof window === 'undefined' ? null : window
  } catch (e) {
    return null
  }
}

function getBrowserDocument() {
  try {
    return typeof document === 'undefined' ? null : document
  } catch (e) {
    return null
  }
}

function getLocationHref() {
  try {
    const win = getBrowserWindow()
    const location = win && win.location
    return location && typeof location.href === 'string' ? location.href : ''
  } catch (e) {
    return ''
  }
}

// 获取当前页面 URL
const initUrl = getLocationHref()

function reportPixelError(error) {
  reportClientError(error)
}

function getFbq() {
  try {
    const win = getBrowserWindow()
    const fbq = win && win.fbq
    if (typeof fbq !== 'function') return null
    return fbq
  } catch (e) {
    return null
  }
}

// 获取 URL 参数
function getUrlIDParams() {
  const queryString = initUrl.match(/[?&]id=([^&]+)/)
  if (queryString && queryString[1]) {
    return queryString[1]
  }
  return ''
}

function getUrlFBParams() {
  const questionMarkIndex = initUrl.indexOf('?')
  const queryString =
    questionMarkIndex !== -1 ? initUrl.substring(questionMarkIndex + 1) : ''
  return queryString
}

// 初始化 Facebook Pixel
function initFacebookPixel() {
  const win = getBrowserWindow()
  const doc = getBrowserDocument()

  try {
    if (!win || !doc || getFbq()) return

    win.fbq = function () {
      win.fbq.callMethod
        ? win.fbq.callMethod.apply(win.fbq, arguments)
        : win.fbq.queue.push(arguments)
    }

    if (!win._fbq) win._fbq = win.fbq
    win.fbq.push = win.fbq
    win.fbq.loaded = true
    win.fbq.version = '2.0'
    win.fbq.queue = []

    const script = doc.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    const head = doc.head || doc.getElementsByTagName('head')[0]
    if (head) head.appendChild(script)
  } catch (error) {
    reportPixelError(error)
  }
}

// 跟踪简单事件
function callTrack(track, name) {
  const fbq = getFbq()
  if (!fbq) return

  try {
    fbq(track, name)
  } catch (error) {
    reportPixelError(error)
  }
}

// 跟踪带有参数的事件
function callTrackHasPara(track, name, valueData, currencyData) {
  const fbq = getFbq()
  if (!fbq) return

  try {
    fbq(track, name, { value: valueData, currency: currencyData })
  } catch (error) {
    reportPixelError(error)
  }
}

// 获取当前的 Facebook Pixel ID
function getFbId() {
  return fb_dynamic_pixelId || ''
}

// 设置新的 Facebook Pixel ID
function setFbId(pixelId) {
  if (pixelId !== fb_dynamic_pixelId) {
    fb_dynamic_pixelId = pixelId || ''
    const fbq = getFbq()
    if (fbq) {
      try {
        fbq('init', pixelId)
      } catch (error) {
        reportPixelError(error)
      }
    }
  }
}

// 向 Android 应用发送事件
function sendEventToAndroid(eventData) {
  try {
    const win = getBrowserWindow()
    const androidInterface = win && win.AndroidInterface
    const appsFlyerEvent = androidInterface && androidInterface.appsFlyerEvent
    if (typeof appsFlyerEvent !== 'function') return

    appsFlyerEvent.call(androidInterface, eventData)
  } catch (error) {
    reportPixelError(error)
  }
}

// 调用 AppsFlyer 事件
function callAppsFlyer(eventData) {
  sendEventToAndroid(eventData)
}

// Vue 插件
const FacebookPixelPlugin = {
  install(Vue) {
    // 初始化 Facebook Pixel
    initFacebookPixel()

    // 将方法挂载到 Vue 原型链上
    Vue.prototype.$pixel = {
      getUrlIDParams,
      getUrlFBParams,
      callTrack,
      callTrackHasPara,
      getFbId,
      setFbId,
      sendEventToAndroid,
      callAppsFlyer
    }
  }
}

export default FacebookPixelPlugin
